var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',{staticClass:"align-self-end",attrs:{"cols":"12","md":"12","sm":"12","order":"1"}},[_c('rx-today')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }